// Minimog雪花效果 - 页面切换优化版
// 切换页面时保留雪花，不重新加载

(function() {
  'use strict';
  
  const config = {
    enabled: true,
    autoEnable: true,
    
    snowCount: {
      desktop: 30,
      tablet: 18,
      mobile: 12
    },
    
    imageSnowRatio: 0.4,
    
    dotSizes: { min: 6, max: 18 },
    
    imageSizes: {
      mobile: { min: 20, max: 45 },
      tablet: { min: 20, max: 60 },
      desktop: { min: 32, max: 100 }
    },
    
    speed: {
      min: 8,
      max: 35
    },
    
    dotColors: [
      'rgba(255, 255, 255, 0.9)',
      'rgba(240, 248, 255, 0.85)',
      'rgba(230, 240, 255, 0.8)'
    ],
    
    excludePages: ['/admin', '/account', '/checkout', '/cart', '/challenge']
  };
  
  let snowflakeImageUrl = '';
  let isImageAvailable = false;
  let snowContainer = null;
  let isInitialized = false;
  let currentPath = window.location.pathname;
  
  // 初始化函数
  function initSnowEffect() {
    if (!shouldShowSnow()) {
      removeSnowEffect();
      return;
    }
    
    // 如果已经初始化且容器存在，只检查是否需要更新
    if (isInitialized && snowContainer && document.body.contains(snowContainer)) {
      updateSnowForCurrentPage();
      return;
    }
    
    // 创建新容器
    createSnowContainer();
    isInitialized = true;
  }
  
  function preloadImage(callback) {
    snowflakeImageUrl = window.minimogSnowConfig?.snowflakeImage || '';
    
    if (!snowflakeImageUrl) {
      isImageAvailable = false;
      callback();
      return;
    }
    
    const img = new Image();
    img.onload = () => { isImageAvailable = true; callback(); };
    img.onerror = () => { isImageAvailable = false; callback(); };
    img.src = snowflakeImageUrl;
  }
  
  function createSnowContainer() {
    // 移除可能存在的旧容器
    const existing = document.getElementById('minimog-snow-container');
    if (existing && existing !== snowContainer) {
      existing.remove();
    }
    
    // 创建新容器
    snowContainer = document.createElement('div');
    snowContainer.id = 'minimog-snow-container';
    snowContainer.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 9998;
      overflow: hidden;
      opacity: 0;
    `;
    
    document.body.appendChild(snowContainer);
    
    preloadImage(() => {
      createAllSnowflakes();
      
      // 淡入效果
      setTimeout(() => {
        snowContainer.style.opacity = '1';
        snowContainer.style.transition = 'opacity 1s ease-out';
      }, 50);
    });
  }
  
  function createAllSnowflakes() {
    if (!snowContainer) return;
    
    // 清空现有雪花
    snowContainer.innerHTML = '';
    
    const width = window.innerWidth;
    let deviceType = 'desktop';
    if (width < 768) deviceType = 'mobile';
    else if (width < 1024) deviceType = 'tablet';
    
    const totalSnowCount = config.snowCount[deviceType];
    const imageSnowCount = isImageAvailable ? 
      Math.floor(totalSnowCount * config.imageSnowRatio) : 0;
    const dotSnowCount = totalSnowCount - imageSnowCount;
    
    // 使用均匀分布算法
    const positions = createEvenPositions(totalSnowCount, deviceType);
    const speeds = createEvenSpeeds(totalSnowCount);
    const delays = createStaggeredDelays(totalSnowCount);
    
    let positionIndex = 0;
    
    // 创建图片雪花
    for (let i = 0; i < imageSnowCount; i++) {
      createSnowflake(i, positions[positionIndex], speeds[positionIndex], 
                     delays[positionIndex], true, deviceType);
      positionIndex++;
    }
    
    // 创建圆点雪花
    for (let i = 0; i < dotSnowCount; i++) {
      createSnowflake(i + imageSnowCount, positions[positionIndex], 
                     speeds[positionIndex], delays[positionIndex], false, deviceType);
      positionIndex++;
    }
  }
  
  function createEvenPositions(total, deviceType) {
    const positions = [];
    
    if (deviceType === 'mobile') {
      // 移动端使用更宽的分布
      const segments = Math.min(total * 2, 20);
      for (let i = 0; i < total; i++) {
        const goldenRatio = 0.6180339887;
        const position = ((i * goldenRatio * 140) % 140) - 20;
        positions.push(position);
      }
    } else {
      for (let i = 0; i < total; i++) {
        positions.push(Math.random() * 100);
      }
    }
    
    return positions.sort(() => Math.random() - 0.5);
  }
  
  function createEvenSpeeds(total) {
    const speeds = [];
    const minSpeed = config.speed.min;
    const speedRange = config.speed.max - config.speed.min;
    
    for (let i = 0; i < total; i++) {
      const speed = minSpeed + (speedRange * i / Math.max(total - 1, 1));
      speeds.push(speed);
    }
    
    return speeds.sort(() => Math.random() - 0.5);
  }
  
  function createStaggeredDelays(total) {
    const delays = [];
    const maxDelay = 25;
    
    if (total <= 1) return [0];
    
    for (let i = 0; i < total; i++) {
      const delay = -(maxDelay * i / (total - 1));
      delays.push(delay);
    }
    
    return delays.sort(() => Math.random() - 0.3);
  }
  
  function createSnowflake(index, startX, duration, delay, isImage, deviceType) {
    if (!snowContainer) return;
    
    const flake = document.createElement('div');
    
    // 大小
    let size;
    if (isImage) {
      const sizes = config.imageSizes[deviceType] || config.imageSizes.desktop;
      size = Math.random() * (sizes.max - sizes.min) + sizes.min;
    } else {
      size = Math.random() * (config.dotSizes.max - config.dotSizes.min) + config.dotSizes.min;
    }
    
    // 透明度
    const opacity = isImage ? 
      (Math.random() * 0.4 + 0.6) : 
      (Math.random() * 0.3 + 0.4);
    
    // 摆动参数
    const swayAmount = deviceType === 'mobile' ? 
      (15 + Math.random() * 15) : 
      (10 + Math.random() * 10);
    const swayDirection = Math.random() > 0.5 ? 1 : -1;
    
    // 设置类名和样式
    flake.className = isImage ? 'snowflake-image' : 'snowflake-dot';
    
    if (isImage && snowflakeImageUrl) {
      flake.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        background: url('${snowflakeImageUrl}') no-repeat center/contain;
        opacity: ${opacity};
        left: ${startX}vw;
        top: -${size}px;
        animation: snow-fall ${duration}s linear infinite;
        animation-delay: ${delay}s;
        will-change: transform;
        filter: blur(${Math.random() * 0.3}px);
        --sway-amount: ${swayAmount}px;
        --sway-direction: ${swayDirection};
      `;
      
      if (index % 4 === 0) {
        flake.style.animation += `, snow-rotate ${duration * 1.5}s linear infinite`;
      }
    } else {
      const color = config.dotColors[Math.floor(Math.random() * config.dotColors.length)];
      flake.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        background: ${color};
        border-radius: 50%;
        opacity: ${opacity};
        left: ${startX}vw;
        top: -${size}px;
        animation: snow-fall ${duration}s linear infinite;
        animation-delay: ${delay}s;
        will-change: transform;
        filter: blur(${Math.random() * 0.8}px);
        box-shadow: 0 0 ${size}px ${color};
        --sway-amount: ${swayAmount}px;
        --sway-direction: ${swayDirection};
      `;
    }
    
    snowContainer.appendChild(flake);
  }
  
  // 页面切换时更新雪花显示状态
  function updateSnowForCurrentPage() {
    if (!snowContainer) return;
    
    const shouldShow = shouldShowSnow();
    
    if (shouldShow) {
      // 显示雪花
      snowContainer.style.opacity = '1';
      snowContainer.style.pointerEvents = 'none';
      snowContainer.style.display = 'block';
      
      // 恢复动画
      const flakes = snowContainer.querySelectorAll('.snowflake-image, .snowflake-dot');
      flakes.forEach(flake => {
        flake.style.animationPlayState = 'running';
      });
    } else {
      // 隐藏雪花
      snowContainer.style.opacity = '0';
      snowContainer.style.pointerEvents = 'none';
      
      // 暂停动画以节省性能
      const flakes = snowContainer.querySelectorAll('.snowflake-image, .snowflake-dot');
      flakes.forEach(flake => {
        flake.style.animationPlayState = 'paused';
      });
    }
  }
  
  function shouldShowSnow() {
    if (!config.enabled) return false;
    if (localStorage.getItem('minimog-snow-disabled') === 'true') return false;
    
    if (config.autoEnable) {
      const month = new Date().getMonth() + 1;
      if (month !== 12) return false;
    }
    
    const path = window.location.pathname;
    for (const page of config.excludePages) {
      if (path.includes(page)) return false;
    }
    
    if (document.body.classList.contains('template-password')) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    
    return true;
  }
  
  function removeSnowEffect() {
    if (snowContainer && document.body.contains(snowContainer)) {
      snowContainer.style.opacity = '0';
      snowContainer.style.transition = 'opacity 0.5s ease-out';
      setTimeout(() => {
        if (snowContainer && snowContainer.parentNode) {
          snowContainer.style.display = 'none';
        }
      }, 500);
    }
    isInitialized = false;
  }
  
  // 全局控制
  window.minimogSnow = {
    toggle: function() {
      if (snowContainer && snowContainer.style.opacity !== '0') {
        removeSnowEffect();
        localStorage.setItem('minimog-snow-disabled', 'true');
      } else {
        localStorage.removeItem('minimog-snow-disabled');
        initSnowEffect();
      }
    },
    
    reload: function() {
      if (snowContainer && document.body.contains(snowContainer)) {
        snowContainer.remove();
      }
      snowContainer = null;
      isInitialized = false;
      setTimeout(initSnowEffect, 100);
    },
    
    show: function() {
      if (snowContainer) {
        snowContainer.style.opacity = '1';
        snowContainer.style.display = 'block';
      }
    },
    
    hide: function() {
      if (snowContainer) {
        snowContainer.style.opacity = '0';
        setTimeout(() => {
          if (snowContainer) snowContainer.style.display = 'none';
        }, 500);
      }
    }
  };
  
  // 监听页面切换
  function setupPageChangeListener() {
    // 监听URL变化（SPA应用）
    let lastUrl = window.location.href;
    
    const observer = new MutationObserver(() => {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        currentPath = window.location.pathname;
        
        // 延迟一小会儿，等新页面内容加载
        setTimeout(updateSnowForCurrentPage, 100);
      }
    });
    
    // 观察整个文档的变化
    observer.observe(document, {
      subtree: true,
      childList: true,
      attributes: true
    });
    
    // 监听浏览器的popstate事件（前进/后退）
    window.addEventListener('popstate', () => {
      setTimeout(updateSnowForCurrentPage, 50);
    });
    
    // 监听Minimog可能使用的Turbo/SPA事件
    document.addEventListener('turbo:load', updateSnowForCurrentPage);
    document.addEventListener('turbo:render', updateSnowForCurrentPage);
    
    // 监听页面可见性变化
    document.addEventListener('visibilitychange', () => {
      if (snowContainer) {
        if (document.hidden) {
          // 页面隐藏时暂停动画
          const flakes = snowContainer.querySelectorAll('.snowflake-image, .snowflake-dot');
          flakes.forEach(flake => {
            flake.style.animationPlayState = 'paused';
          });
        } else {
          // 页面显示时恢复动画
          const flakes = snowContainer.querySelectorAll('.snowflake-image, .snowflake-dot');
          flakes.forEach(flake => {
            flake.style.animationPlayState = 'running';
          });
        }
      }
    });
  }
  
  // 初始化
  function init() {
    // 延迟初始化，避免阻塞页面加载
    setTimeout(() => {
      initSnowEffect();
      setupPageChangeListener();
    }, 1000);
  }
  
  // DOM加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // 窗口大小变化时重新创建雪花（保持容器）
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (snowContainer && document.body.contains(snowContainer)) {
        createAllSnowflakes();
      }
    }, 400);
  });
  
})();